//
// Useful functions and classes
// --------------------------------------------------

// Cookies
export const setCookie = (cname, cvalue, exdays) => {
	const d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	document.cookie = `${cname}=${cvalue};expires=${d.toUTCString()};path=/`;
};

export const setHourlyCookie = (cname, cvalue, exhours) => {
	const d = new Date();
	d.setTime(d.getTime() + exhours * 60 * 60 * 1000);
	const expires = `expires=${d.toUTCString()}`;
	document.cookie = `${cname}=${cvalue};${expires};path=/`;
};

export const getCookie = (cname) => {
	const name = `${cname}=`;
	const ca = document.cookie.split(";");
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
};

export const deleteCookie = (cname) => {
	document.cookie = `${cname}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
};

export const loadScript = (name, src) => {
	return new Promise((resolve, reject) => {
		if (document.querySelector(`#${name}-js`)) {
			console.log(`Already loaded: ${src}`);
			resolve(document.querySelector(`#${name}-js`).getAttribute("src"));
		} else {
			const script = document.createElement("script");
			script.src = src;
			script.id = `${name}-js`;
			script.async = true;
			script.src = src;

			script.onload = () => {
				console.log(`Loaded: ${src}`);
				resolve(src);
			};
			script.onerror = () => {
				reject(`Error: ${src} not loaded`);
			};
			document.body.appendChild(script);
		}
	});
};

export const loadScripts = (scripts) => {
	return new Promise((resolve, reject) => {
		const promises = [];
		for (const script of scripts) {
			promises.push(loadScript(script.name, script.src));
		}
		Promise.all(promises)
			.then((results) => {
				resolve(results);
			})
			.catch((error) => {
				reject(error);
			});
	});
};

// Csrf
export const formAddCsrfProtection = async (form) => {
	if (!!form.querySelector("input[name='csrfmiddlewaretoken']") === false) {
		await fetch("/csrf/", {
			headers: {
				"X-Requested-With": "XMLHttpRequest",
			},
			cache: "no-cache",
		})
			.then((response) => {
				return response.text();
			})
			.then((data) => {
				const input = document.createElement("span");
				input.innerHTML = data;
				form.appendChild(input.firstChild);
			})
			.catch((error) => {
				console.warn(" --- Error: ", error);
			});
	}
};

export const getCsrfToken = async () => {
	const token = await fetch("/misc/csrf-token/", {
		headers: {
			"X-Requested-With": "XMLHttpRequest",
		},
		cache: "no-cache",
	})
		.then((response) => {
			return response.json();
		})
		.then((data) => {
			return data.token;
		})
		.catch((error) => {
			console.warn(" --- Error: ", error);
		});
	return token;
};

// Lightbox
export const initAjaxLightbox = (elements, css_class = "") => {
	for (const el of elements) {
		el.addEventListener("click", (event) => {
			event.preventDefault();
			fetch(event.currentTarget.href, {
				headers: {
					"X-Requested-With": "XMLHttpRequest",
				},
			})
				.then((response) => response.text())
				.then((data) => {
					import("basiclightbox").then((basicLightbox) => {
						const lightbox = basicLightbox.create(data, {
							className: css_class,
						});
						lightbox.show();
					});
				})
				.catch((error) => {
					console.warn(error);
				});
		});
	}
};

// url parameters
export const getUrlParam = (param) => {
	const querystring = window.location.search.substring(1);
	const parameters = querystring.split("&");
	for (let i = 0; i < parameters.length; i++) {
		const bits = parameters[i].split("=");
		if (bits[0] === param) {
			return bits[1];
		}
	}
};

// fixes INP issues by yielding on medium and background tasks
export const yieldToMainBackground = () => {
	return new Promise((resolve) => {
		if ("scheduler" in window) {
			if ("yield" in window.scheduler) {
				return window.scheduler.yield().then(() => resolve(true));
			}

			if ("postTask" in window.scheduler) {
				return window.scheduler.postTask(() => resolve(true), {
					priority: "user-visible",
				});
			}
		}
		setTimeout(() => {
			resolve(true);
		}, 0);
	});
};

// GA4
export const updateGAdataLayer = (event_name, key = null, value = null) => {
	window.dataLayer = window.dataLayer || [];
	if (key && value) {
		window.dataLayer.push({
			event: event_name,
			[key]: value,
		});
	} else {
		window.dataLayer.push({
			event: event_name,
		});
	}
};
// Publytics
export const sendPublyticsEvent = (event_name, values = null) => {
	// biome-ignore format lint: reason=external script
	window.publytics = window.publytics || function() { (window.publytics.q = window.publytics.q || []).push(arguments) };
	if (values) {
		publytics(event_name, { props: values });
	} else {
		publytics(event_name);
	}
};

export const userNotifications = () => {
	if (document.querySelectorAll("._notification.new").length === 0) {
		for (const el of document.querySelectorAll("._notifications_mark_read")) {
			el.classList.add("disabled");
		}
	}
	if (document.querySelector("#_user_notifications")) {
		const marker_url = user_nav.querySelector("#_user_notifications").dataset
			.markerUrl;
		for (const el of document.querySelectorAll("._notification")) {
			el.addEventListener("click", function () {
				const notification_id = this.dataset.notification_id;
				fetch(`${marker_url}?id=${notification_id}`, {
					headers: {
						"X-Requested-With": "XMLHttpRequest",
					},
					cache: "no-cache",
				})
					.then((response) => {
						if (response.ok) {
							if (
								document.querySelectorAll("._notification.new").length === 0
							) {
								user_nav
									.querySelector("#_notification_counter")
									.classList.remove("on");
								for (const el of document.querySelectorAll(
									"._notifications_mark_read",
								)) {
									el.classList.add("disabled");
								}
							}
						}
					})
					.catch((error) => {
						console.warn(error);
					});
			});
		}
		for (const el of document.querySelectorAll("._notifications_mark_read")) {
			el.addEventListener("click", (event) => {
				event.stopPropagation();
				fetch(marker_url, {
					headers: {
						"X-Requested-With": "XMLHttpRequest",
					},
					cache: "no-cache",
				})
					.then((response) => {
						if (response.ok) {
							for (const el of document.querySelectorAll("._notification")) {
								el.classList.remove("new");
							}
							user_nav
								.querySelector("#_notification_counter")
								.classList.remove("on");

							for (const el of document.querySelectorAll(
								"._notifications_mark_read",
							)) {
								el.classList.add("disabled");
							}
						}
					})
					.catch((error) => {
						console.warn(error);
					});
			});
		}
	}
};

// setup Twitch Plus button
export const plusTwitch = (user_status) => {
	const button = document.querySelector("#_twitch_plus");
	if (button) {
		if (user_status === "plus") {
			button.setAttribute("href", button.dataset.profile);
		} else {
			button.setAttribute("href", button.dataset.twitch);
		}
		button.classList.remove("disabled");
		button.addEventListener("click", (event) => {
			event.target.classList.add("disabled");
		});
	}
};

export class CmpCheck {
	constructor() {
		this.show_ads = null;
	}
	async checkConsent() {
		if (this.show_ads === null) {
			return new Promise((resolve, reject) => {
				if ("debug" in document.body.dataset) {
					this.show_ads = true;
					resolve(this.show_ads);
				}
				window.__tcfapi?.("addEventListener", 2, (tcData, success) => {
					if (success && tcData) {
						if (!tcData.gdprApplies) {
							this.show_ads = true;
							resolve(this.show_ads);
						}
						if (
							tcData.eventStatus === "tcloaded" ||
							tcData.eventStatus === "useractioncomplete"
						) {
							__tcfapi(
								"removeEventListener",
								2,
								(_success) => {},
								tcData.listenerId,
							);
							// console.log({ tcData });
							if (
								Object.keys(tcData.purpose.consents).length === 0 &&
								tcData.purpose.consents.constructor === Object
							) {
								this.show_ads = false;
								resolve(this.show_ads);
							} else {
								this.show_ads = true;
								resolve(this.show_ads);
							}
						}
					}
				});
			});
		}
		return this.show_ads;
	}
}

export const isMobile = () => {
	const device = document.body.dataset.device;
	if (device === "mobile") {
		return true;
	}
	return false;
};

export const loadEndless = async () => {
	const module = await import(
		"endless_pagination/endless-pagination-module.js"
	);
	return module.endlessPaginate;
};

export const isDebug = () => {
	return document.body.dataset.debug === "true";
};
